import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { SignInPageTemplate } from "components/signIn/signInPageTemplate/signInPageTemplate"
import { RegisterForm } from "components/signIn/registerForm/registerForm"
import {
  RegistrationConfirmation,
} from "components/signIn/registrationConfirmation/registrationConfirmation"

export interface RegisterPageProps {

}

export const RegisterPage = (props: RegisterPageProps) => {
  const [ isRegistered, setIsRegistered ] = useState(false)
  const navigate = useNavigate()

  const goToSignIn = () => navigate("/sign-in")

  return (
    <SignInPageTemplate heading={isRegistered ? "Registrering sendt" : "Ny bruker"}>
      {isRegistered
        ? <RegistrationConfirmation onClickSignIn={goToSignIn} />
        : <RegisterForm onRegistered={() => setIsRegistered(true)} onCancel={goToSignIn} />}
    </SignInPageTemplate>
  )
}
